import { API } from "../../../api/constants"
import { MajorOrderGet, OfferTextTemplate } from "../../../data/Types"
import { authenticatedAxiosInstance } from "../../../auth/AuthenticatedAxios"
import { Dayjs } from "dayjs"

export const getBillByObject = (id: string) => authenticatedAxiosInstance.get(API + "/bill/get/object/" + id).then((res) => res.data)

export const getSingleBillData = (id: string) => authenticatedAxiosInstance.get(API + "/bill/get/" + id).then((res) => res.data)

export const getSingleBillTemplateData = (id: string) => authenticatedAxiosInstance.get(API + "/bill-template/" + id).then((res) => res.data)

export const getSingleMajorOrderData = (data: { id: string; minimal?: string }) =>
    authenticatedAxiosInstance.get(API + "/major-order/" + data.id, { params: { minimal: data.minimal } }).then((res) => res.data)

export const getOfferByObject = (id: string) => authenticatedAxiosInstance.get(API + "/offer/get/object/" + id).then((res) => res.data)

export const getSingleOfferData = (id: string, minimal?: string) => authenticatedAxiosInstance.get(API + "/offer/get/" + id + (minimal ? `?minimal=${minimal}` : "")).then((res) => res.data)

export const getOfferTextTemplate = () => authenticatedAxiosInstance.get(API + "/offer/template/text/get/all").then((res) => res.data)

export const postNewOffer = (body: any, leistungsVerzeichnis: boolean) =>
    authenticatedAxiosInstance
        .post(API + "/offer/add?withLeistungsVerzeichnis=" + leistungsVerzeichnis.toString(), body, {
            headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => res.data)

export const postTextTemplates = (body: OfferTextTemplate[]) => authenticatedAxiosInstance.post(API + "/offer/template/text/add", body).then((res) => res.data)

export const statusOffer = (data: { id: string; body: { status: string } }) => authenticatedAxiosInstance.patch(API + "/offer/status/update/" + data.id, data.body).then((res) => res.data)

export const archiveOffer = (data: { id: string; body: { archived: boolean } }) => authenticatedAxiosInstance.patch(API + "/offer/archive/update/" + data.id, data.body).then((res) => res.data)

export const postNewBill = (body: any) => authenticatedAxiosInstance.post(API + "/bill/add", body, { headers: { "Content-Type": "multipart/form-data" } }).then((res) => res.data)

export const postNewBillTemplate = (body: FormData) => authenticatedAxiosInstance.post(API + "/bill-template/add", body, { headers: { "Content-Type": "multipart/form-data" } }).then((res) => res.data)

export const postNewMajorOrder = (body: FormData) => authenticatedAxiosInstance.post(API + "/major-order/add", body, { headers: { "Content-Type": "multipart/form-data" } }).then((res) => res.data)

export const archiveBill = (data: { id: string; body: { archived: boolean } }) => authenticatedAxiosInstance.patch(API + "/bill/archive/update/" + data.id, data.body).then((res) => res.data)

export const updateNoteOfBill = (data: { id: string; body: { note: string } }) => authenticatedAxiosInstance.patch(API + "/bill/note/" + data.id, data.body).then((res) => res.data)

export const cancelBill = (data: { id: string; cancelUnpaidPaymentRequirements: boolean }) =>
    authenticatedAxiosInstance.post(API + `/bill/${data.id}/cancel?cancelUnpaidPaymentRequirements=${data.cancelUnpaidPaymentRequirements}`).then((res) => res.data)

export const solvePaymentEscalation = (id: String) => authenticatedAxiosInstance.patch(API + "/paymentrequirements/solve-escalation/" + id).then((res) => res.data)

export const getAssignedTransactionsOfPayment = (ids: string[]) =>
    authenticatedAxiosInstance
        .get(API + "/banking/by-ids", {
            params: { ids: ids.join(",") },
        })
        .then((res) => res.data)

export const refetchTransactions = () => authenticatedAxiosInstance.get(API + "/banking/fetch-updates").then((res) => res.data)

export const markPayreqAsPaidManually = (id: string) => authenticatedAxiosInstance.patch(API + `/paymentrequirements/${id}/mark-as-settled`).then((res) => res.data)

export const markPayreqAsUnpaidManually = (id: string) => authenticatedAxiosInstance.patch(API + `/paymentrequirements/${id}/mark-as-unsettled`).then((res) => res.data)

export const exportBillsFromTimeframe = (data: { startDate: Dayjs; endDate: Dayjs }) => authenticatedAxiosInstance.post(API + `/bill/batch-export`, data).then((res) => res.data)

export const pausePaymentReminder = (data: { pid: string; days: number }) =>
    authenticatedAxiosInstance.patch(API + `/paymentrequirements/${data.pid}/pause-reminder/${data.days}`).then((res) => res.data)

export const archiveBillTemplate = (data: { id: string; archived: boolean }) => authenticatedAxiosInstance.patch(API + `/bill-template/${data.id}/archive/${data.archived}`).then((res) => res.data)

export const getMajorOrderNamesOnly = (searchParams: string) =>
    authenticatedAxiosInstance.get(API + `/major-order/paginate/names-only` + (searchParams ? `?search=${searchParams}` : "")).then((res) => res.data)

export const archiveMajorOrder = (data: { id: string; archived: boolean }) => authenticatedAxiosInstance.patch(API + `/major-order/${data.id}/archive/${data.archived}`).then((res) => res.data)

export const updateMajorOrder = (data: { id: string; data: MajorOrderGet }) => authenticatedAxiosInstance.patch(API + `/major-order/${data.id}`, data.data).then((res) => res.data)

export const cancelBillTemplate = (id: string) => authenticatedAxiosInstance.patch(API + `/bill-template/${id}/cancel`).then((res) => res.data)

// ==================================================== BANKING =====================================================  //

export const getPaymentStatistics = (data: { monthStart: Date; monthEnd: Date }) => authenticatedAxiosInstance.get(API + `/dashboard/${data.monthStart}/${data.monthEnd}`).then((res) => res.data)

export const getPaymentRequirementFromBillData = (id: string) => authenticatedAxiosInstance.get(API + "/paymentrequirements/get/from/bill/" + id).then((res) => res.data)

export const updateTransactionAndBillData = (data: { pid: string; tid: string }) =>
    authenticatedAxiosInstance.patch(API + `/banking/assign/transaction/${data.tid}/payReq/${data.pid}`).then((res) => res.data)

export const updateTransactionAndBillPullData = (data: { pid: string; tid: string }) =>
    authenticatedAxiosInstance.patch(API + `/banking/unassign/transaction/${data.tid}/payReq/${data.pid}`).then((res) => res.data)

export const ignoreTransaction = (tid: string) => authenticatedAxiosInstance.patch(API + `/banking/ignore/transaction/${tid}`).then((res) => res.data)

export const setReminder = (id: String) => authenticatedAxiosInstance.post(API + `/paymentrequirements/${id}/send-next-reminder`).then((res) => res.data)

// ==================================================== CREDIT =====================================================  //

export const createCredit = (data: {
    paymentRequirement: string
    bill: string
    comment: string
    positions: {
        position_id: string
        refundAmountNetto: number
        refundAmountBrutto: number
        reducedAmount: number
        description: string
        unit: string
        tax: number
    }[]
}) => authenticatedAxiosInstance.post(API + `/credit`, data).then((res) => res.data)
